import React from "react";
import { selectCurrentPatient } from "store/PatientStore/selectors";
import { useAppSelector } from "hooks/reduxHooks";
import Skeleton from "react-loading-skeleton";
import { PatientInfo } from "../../components/Patient/PatientInfo";
import { selectRequests } from "../../../../store/LoadingStore/selectors";
import { Requests } from "../../../../types/requests";

export const PatientInfoContainer = () => {
  const patient = useAppSelector(selectCurrentPatient);
  const loading = useAppSelector((state) =>
    selectRequests([Requests.getPatient], state)
  );

  const getTeamLead = () => {
    const assignedTeamLead = patient?.assignedTeamLead?.[0];

    if (!assignedTeamLead) {
      return "";
    }

    const { firstName, lastName } = assignedTeamLead.profileInfo || {};
    if (!firstName && !lastName) return "";
    return `${firstName ?? ""} ${lastName ?? ""}`.trim();
  };

  return (
    <div>
      {loading ? (
        <Skeleton height={180} />
      ) : (
        <PatientInfo
          firstName={patient?.profileInfo?.firstName}
          lastName={patient?.profileInfo?.lastName}
          uniqueId={patient?.profileInfo?.mrn}
          patientImage={patient?.imageUrl}
          dateOfBirth={patient?.profileInfo?.dateOfBirth}
          email={patient?.profileInfo?.email}
          gender={patient?.profileInfo?.gender}
          phone={patient?.profileInfo?.phoneNumber}
          id={patient?._id}
          teamLead={getTeamLead()}
          teamMembers={patient?.assignedTeamMembers ?? []}
        />
      )}
    </div>
  );
};
